import { Schema } from "effect";

export const RESERVATION_RESOURCE_CLASSES = [
  "agent",
  "build",
  "browser",
  "container"
] as const;
export const ReservationResourceClass = /* @__PURE__ */ (() => Schema.Literals(RESERVATION_RESOURCE_CLASSES))();
export type ReservationResourceClass = typeof ReservationResourceClass.Type;
